import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  createLibrarySortSlice,
  LibrarySortBy,
  LibrarySortDirection,
  type LibrarySortSlice,
} from '~/components/v2/store/shared/creareLibrarySortSlice';
import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';

export type WorkspaceSidebarLibrariesState = LibrarySortSlice;

export const useWorkspaceSidebarLibrariesStore = create<WorkspaceSidebarLibrariesState>()(
  persist(
    (...args) => ({
      ...createLibrarySortSlice({
        librarySortBy: LibrarySortBy.Title,
        librarySortDirection: LibrarySortDirection.Asc,
      })(...args),
    }),
    {
      name: ZustandStorageKeys.WorkspaceSidebarLibraries,
      partialize: (state) => ({
        librarySortBy: state.librarySortBy,
        librarySortDirection: state.librarySortDirection,
      }),
      version: 2,
    },
  ),
);
